<script lang="ts">
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import {MarkdownRichTextDisplay} from 'shared/ui-widgets/markdown-richtext-area';
    import KpModalHeaderCloseButton from 'src/modals/kp-modal/KpModalHeaderCloseButton.svelte';
    import KpModalContent from 'src/modals/kp-modal/KpModalContent.svelte';
    import KpModalTitle from 'src/modals/kp-modal/KpModalTitle.svelte';
    import KpModalFooterCloseButton from 'src/modals/kp-modal/KpModalFooterCloseButton.svelte';
    import Loc from 'shared/components/kp-markdown/Loc.svelte';

    export let model: {
        markdown: string;
    };
    export let modalWindowActions: ModalWindowActions;
</script>

<KpModalContent {modalWindowActions} additionalClasses="markdown-value-display-modal">
    <svelte:fragment slot="header">
        <KpModalTitle>
            <Loc code="richTextArea.editor.formattedTextModalTitle"/>
        </KpModalTitle>
        <KpModalHeaderCloseButton/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <MarkdownRichTextDisplay markdown={model.markdown}/>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpModalFooterCloseButton/>
    </svelte:fragment>
</KpModalContent>